import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { ResultsData } from "../../state/ProviderPreferences/ResultsData";

const updateResultsData: Reducer<ResultsData> = (state: ResultsData = new ResultsData(), action: Action<ActionType, ResultsData>) => {
  switch (action.type) {
    case ActionType.PROVIDER_PREFERENCES_DATA_FETCHED:
      return { ...state, items: action.data.businessData };
    case ActionType.PROVIDER_PREFERENCES_DATA_UPDATED:
    default:
      return state;
  }
};

export default updateResultsData;
